import { Component, Directive, ChangeDetectionStrategy } from '@angular/core';
import { BbTemplate } from '@backbase/foundation-ang/core';

@Component({
  selector: 'bb-transaction-signing-action-pending',
  templateUrl: 'action-pending.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningActionPendingComponent {
  readonly hostRef = this;
}

@Directive({
  selector: '[bbTransactionSigningActionPendingCustomizable]',
})
export class TransactionSigningActionPendingCustomizableDirective extends BbTemplate<
  TransactionSigningActionPendingComponent,
  undefined
> {}
